const STORAGE_KEY = "pomot_count";

function clampPomot(value) {
  const n = Number(value);
  if (!Number.isFinite(n) || n < 0) {
    return 0;
  }
  return n;
}

export function readPomotStore() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) {
      return [];
    }
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

function writePomotStore(store) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(store));
  } catch (e) {
    console.error("pomotLocalStorage: failed to save", e);
  }
}

/**
 * @param {number} companyId
 * @param {string} labelKey
 * @returns {number}
 */
export function getPomot(companyId, labelKey) {
  const id = Number(companyId);
  const key = String(labelKey).toLowerCase();
  const store = readPomotStore();
  const company = store.find((c) => Number(c.company_id) === id);
  if (!company || !Array.isArray(company.labels)) {
    return 0;
  }
  const row = company.labels.find(
    (l) => String(l.name).toLowerCase() === key,
  );
  return row ? clampPomot(row.pomot) : 0;
}

/**
 * @param {number} companyId
 * @param {string} labelKey
 * @param {number} value
 */
export function setPomot(companyId, labelKey, value) {
  const id = Number(companyId);
  const key = String(labelKey).toLowerCase();
  const pomot = clampPomot(value);
  const store = readPomotStore();
  let company = store.find((c) => Number(c.company_id) === id);
  if (!company) {
    company = { company_id: id, labels: [] };
    store.push(company);
  }
  if (!Array.isArray(company.labels)) {
    company.labels = [];
  }
  const existing = company.labels.find(
    (l) => String(l.name).toLowerCase() === key,
  );
  if (existing) {
    existing.name = key;
    existing.pomot = pomot;
  } else {
    company.labels.push({ name: key, pomot });
  }
  writePomotStore(store);
}
